import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { MapPin, CheckCircle2, CalendarDays } from 'lucide-react';

export const CSRProjectCard = ({ p }) => (
    <Card
        className="h-full overflow-hidden bg-card border-border shadow-[0_10px_30px_rgba(15,23,42,0.05)] card-lift"
        data-testid="csr-project-card"
    >
        {p.image_url && (
            <div className="aspect-[16/10] overflow-hidden bg-muted">
                <img
                    src={p.image_url}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
            </div>
        )}
        <CardContent className="p-5">
            <div className="flex items-center gap-2 mb-2 flex-wrap">
                <Badge
                    className={
                        p.status === 'ongoing'
                            ? 'bg-[hsl(var(--accent))]/15 text-[hsl(30_90%_28%)] border-[hsl(var(--accent))]/30'
                            : 'bg-[hsl(142_45%_92%)] text-[hsl(142_45%_26%)] border-[hsl(142_35%_78%)]'
                    }
                >
                    {p.status === 'ongoing' ? 'Ongoing' : 'Completed'}
                </Badge>
                <Badge variant="outline" className="text-[10px]">
                    {p.category}
                </Badge>
            </div>
            <div className="font-display font-semibold text-lg leading-snug mb-1">
                {p.title}
            </div>
            <div className="text-xs text-muted-foreground flex items-center gap-3 flex-wrap">
                {p.location && (
                    <span className="flex items-center gap-1">
                        <MapPin className="h-3 w-3" /> {p.location}
                    </span>
                )}
                {p.start_date && (
                    <span className="flex items-center gap-1">
                        <CalendarDays className="h-3 w-3" /> {p.start_date}
                    </span>
                )}
            </div>
            <p className="mt-3 text-sm text-foreground/80 line-clamp-4">
                {p.summary || p.description}
            </p>
            {p.beneficiaries && (
                <div className="mt-3 text-xs text-[hsl(var(--primary))] font-medium">
                    Beneficiaries: {p.beneficiaries}
                </div>
            )}
            {p.outcomes?.length > 0 && (
                <ul className="mt-3 space-y-1">
                    {p.outcomes.slice(0, 3).map((o) => (
                        <li key={o} className="flex items-start gap-2 text-xs text-foreground/80">
                            <CheckCircle2 className="h-3.5 w-3.5 mt-0.5 text-[hsl(var(--accent))] shrink-0" />
                            {o}
                        </li>
                    ))}
                </ul>
            )}
        </CardContent>
    </Card>
);

export default CSRProjectCard;
